import React from 'react';
import styles from './banner.module.scss';


class Banner extends React.Component {

  render () {
    return (
      <div className={styles.banner}>
        <div className={'container'}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner/index.js